/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 意见反馈/投诉举报/注销申请
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  feedbackDto: member.FeedbackDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/setting/feedback`,
    data: feedbackDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
